import { Avatar, AvatarGroup, AvatarBadge } from '@chakra-ui/react';
export const CUIAvatarBadge = AvatarBadge;
export const CUIAvatarGroup = AvatarGroup;
export const CUIAvatar = Avatar;